export default __webpack_public_path__ + "static/media/healthgenom@3x.971dbb1c.png";